import { defaultFont } from "assets/jss/material-kit-react.js";

const headerLinksStyle = theme => ({
  list: {
    ...defaultFont,
    fontSize: "14px",
    margin: 0,
    paddingLeft: "0",
    listStyle: "none",
    paddingTop: "0",
    paddingBottom: "0",
    color: "inherit"
  },
  listItem: {
    float: "left",
    color: "inherit",
    position: "relative",
    display: "block",
    width: "auto",
    margin: "0",
    padding: "0",
    [theme.breakpoints.down("md")]: {
      width: "100%",
      "&:after": {
        width: "calc(100% - 30px)",
        content: '""',
        display: "block",
        height: "1px",
        marginLeft: "15px",
        backgroundColor: "#e5e5e5"
      }
    }
  },
  listItemText: {
    padding: "0 !important"
  },
  navLink: {
    position: "relative",
    padding: "0.9375rem",
    borderRadius: "3px",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    color: "#081624",
    fontFamily: "Open Sans, sans-serif",
    textTransform: "none",
    fontSize: 14,
    fontWeight: 600,
    background: "transparent",
    boxShadow: "none",
    "&:hover,&:focus": {
      color: "inherit",
      background: "rgba(200, 200, 200, 0.2)",
      boxShadow: "none"
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    }
  },
  profilebutton: {
    position: "relative",
    padding: "0.9375rem",
    borderRadius: "50px",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    color: "#ffffff",
    fontFamily: "Open Sans, sans-serif",
    textTransform: "none",
    fontSize: 14,
    fontWeight: 600,
    "&:hover,&:focus": {
      color: "inherit",
      background: "rgba(200, 200, 200, 0.2)"
    },
    [theme.breakpoints.down("md")]: {
      width: "calc(100% - 30px)",
      marginLeft: "15px",
      marginBottom: "8px",
      marginTop: "8px",
      textAlign: "left",
      "& > span:first-child": {
        justifyContent: "flex-start"
      }
    }
  },
  notificationNavLink: {
    color: "inherit",
    padding: "0.9375rem",
    fontWeight: "400",
    fontSize: "12px",
    textTransform: "uppercase",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "0px",
    display: "inline-flex",
    top: "4px"
  },
  registerNavLink: {
    position: "relative",
    fontWeight: "600",
    fontSize: "14px",
    fontFamily: "Open Sans, sans-serif",
    textTransform: "none",
    lineHeight: "20px",
    textDecoration: "none",
    margin: "4px 0 4px 15px",
    height: "42px",
    display: "inline-flex",
    [theme.breakpoints.down("md")]: {
      margin: "10px 0 10px 15px"
    }
  },
  navLinkActive: {
    color: "inherit",
    backgroundColor: "rgba(255, 255, 255, 0.1)"
  },
  icons: {
    width: "20px",
    height: "20px",
    marginRight: "3px"
  },
  socialIcons: {
    position: "relative",
    fontSize: "20px !important",
    marginRight: "4px"
  },
  dropdownLink: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
      padding: "10px 20px",
      fontFamily: "Open Sans, sans-serif"
    },
    "&:hover,&:focus": {
      fontWeight: 600
    }
  },
  dropdownButton: {
    "&,&:hover,&:focus": {
      color: "inherit",
      textDecoration: "none",
      display: "block",
      padding: "10px 20px",
      fontFamily: "Open Sans, sans-serif",
      textTransform: "capitalize",
      fontSize: "13px"
    },
    "&:hover,&:focus": {
      fontWeight: 600
    }
  }
});

export default headerLinksStyle;
